import { useEffect, useRef } from "react";
import { useApi } from "hooks/useApi/useApiHooks";

/* Mijozlarning yaqinlashayotgan tug'ilgan kunlari. Necha kun oldin
   ogohlantirish kerakligini backend sozlamalardan o'zi oladi, shuning
   uchun bu yerda kun soni berilmaydi. */

export interface IUpcomingBirthday {
  _id: string;
  firstName?: string;
  lastName?: string;
  familyName?: string;
  phoneNumber?: string;
  /** "DD.MM.YYYY" */
  BirthDate: string;
  /** Bugundan necha kun qolgani, 0 = bugun */
  daysLeft: number;
  age?: number;
}

/* Tug'ilgan kunlar kun davomida o'zgarmaydi - tez-tez so'rashning
   ma'nosi yo'q. Yarim soatda bir marta yetarli va sana yarim tunda
   almashsa ham ertalabgacha yangilanadi. */
const REFETCH_MS = 30 * 60 * 1000;

const CHIME_STORAGE_KEY = "birthdayChimeDate";

/* Ovoz uchun fayl qo'shilmadi: Web Audio bilan qisqa ikki notali
   signal yaratiladi. Fayl bo'lmagach yuklanish, keshlash va yo'l
   muammolari ham yo'q. */
function playChime() {
  try {
    const Ctx =
      (window as any).AudioContext || (window as any).webkitAudioContext;
    if (!Ctx) return;

    const ctx = new Ctx();
    const now = ctx.currentTime;

    /* Ikki nota: mi - do (yumshoq, ogohlantiruvchi emas) */
    [
      { freq: 880, at: 0 },
      { freq: 1174.7, at: 0.16 },
    ].forEach(({ freq, at }) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      /* Tez ko'tarilib sekin so'nadi - "chiq" degan ovoz chiqmasligi uchun */
      gain.gain.setValueAtTime(0, now + at);
      gain.gain.linearRampToValueAtTime(0.18, now + at + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + at + 0.42);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(now + at);
      osc.stop(now + at + 0.45);
    });

    /* Kontekst ochiq qolsa brauzer resursni ushlab turadi */
    setTimeout(() => ctx.close().catch(() => {}), 1200);
  } catch {
    /* Brauzer foydalanuvchi harakatisiz ovozni bloklashi mumkin -
       bu xato emas, qo'ng'iroq baribir ko'rinadi. */
  }
}

export function useBirthdayAlert(enabled = true) {
  const { data } = useApi<IUpcomingBirthday[]>(
    "customer/birthdays",
    {},
    {
      enabled,
      suspense: false,
      toast: false,
      refetchInterval: REFETCH_MS,
      staleTime: REFETCH_MS,
      retry: false,
    }
  );

  const birthdays: IUpcomingBirthday[] = Array.isArray(data?.data)
    ? (data?.data as IUpcomingBirthday[])
    : [];

  const chimedRef = useRef(false);

  useEffect(() => {
    if (!enabled || !birthdays.length || chimedRef.current) return;

    /* Kuniga bir marta: sahifa har yangilanganda ovoz chiqarsa
       charchatadi, lekin ertasi kuni yana eslatishi kerak. */
    const today = new Date().toDateString();
    if (localStorage.getItem(CHIME_STORAGE_KEY) === today) {
      chimedRef.current = true;
      return;
    }

    localStorage.setItem(CHIME_STORAGE_KEY, today);
    chimedRef.current = true;
    playChime();
  }, [birthdays.length, enabled]);

  return birthdays;
}
